const localeDetectionRegExp = /^\/[\w]{2}(-|_)[\w]{2}\/|^\/(\w{2})\//;
const defaultBrand = localStorage?.getItem("helpAppDefaultBrand") || "dlr";

export const brands = {
	disneyland: "dlr",
	disneyworld: "wdw",
	disneycruise: "dcl",
	disneybeachresorts: "beachresorts",
	disneyaulani: "aulani",
	hiltonhead: "hh",
	hongkongdisneyland: "hkdl",
	verobeach: "vb",
	default: defaultBrand,
};
const storesStartPath = "reservations";
const topics = ["help", "faq"];

export const mapString = (target = "", ...args) => {
	let index = -1;
	return target.replace(/{[a-zA-Z0-9._-]+}/gi, () => {
		index++;
		return args[index];
	});
};

export const isRelativeUrl = (url) => {
	return url?.[0] === "/";
};

export const parseBoolean = function (val) {
	const falsy = /^(?:f(?:alse)?|no?|0+)$/i;
	return !falsy.test(val) && !!val;
};

export const loadBrandParam = () => {
	const splittedHostname = window.location.hostname.split(".");
	for (const brand in brands) {
		if (splittedHostname.includes(brand)) {
			return brands[brand];
		}
	}
	return brands.default;
};

export const isInternalUrl = (url) => {
	if (!url) return url;
	const path = sanitizeUrl(url);
	return isRelativeUrl(url) && topics.includes(path.split("/")[1]);
};

export const isAriaCurrent = (url) => {
	if (!isRelativeUrl(url)) return false;
	const transformedUrl = new URL(url, window.location.origin);
	const transformedPathname = validateSlashAtTheEnd(transformedUrl.pathname);
	return isCurrentPathPresent([transformedPathname]);
};

export const getStore = () => {
	const pathname = window.location.pathname;
	const pathnameParts = pathname.split("/");
	const storesStartIndex = pathnameParts.findIndex(
		(subpath) => subpath === storesStartPath
	);
	if (storesStartIndex !== -1 && pathnameParts[storesStartIndex + 1]) {
		return pathnameParts[storesStartIndex + 1];
	}
	return null;
};

export const sanitizeUrl = (url) => {
	const localeMatches = url.match(localeDetectionRegExp);
	if (localeMatches) {
		url = `/${url}`.replace(localeMatches[0], "");
	}
	const store = getStore();
	if (store) {
		url = url.replace(`/${storesStartPath}/${store}`, "");
	}
	url = validateSlashAtTheEnd(url);
	return url;
};

export const isCurrentPathPresent = (listOfPaths = []) => {
	const { pathname } = window.location;
	const path = sanitizeUrl(pathname);
	return listOfPaths?.some((rule) =>
		path.match(`^${rule.replace("*", ".*")}$`)
	);
};

export const getLastPathSegment = () =>
	window.location.pathname.split("/").filter(Boolean).pop();

export const validateSlashAtTheEnd = (url) => {
	const endWithSlash = url.charAt(url.length - 1) === "/";
	if (endWithSlash) return url;
	const lastPath = getLastPath(url);
	if (!lastPath.match(/[?|#]+/)) {
		return `${url}/`;
	}
	return url;
};

export const addClassToWrapper = (paths = []) => {
	if (!document.getElementById("root")) return;
	const { pathname } = window.location;
	const modifierClass = getLastPath(pathname);
	const classes = document.getElementById("root").firstChild.classList;
	const classToRemove = [...classes].slice(1);
	if (isCurrentPathPresent(paths)) {
		classes.add(`help-wrapper__main--${modifierClass}`);
	} else {
		classes.remove(...classToRemove);
	}
};

export const addClassToBody = (paths = [], className) => {
	if (isCurrentPathPresent(paths)) {
		document.body.classList.add(className);
		return;
	}
	document.body.classList.remove(className);
};

const getLastPath = (pathName) => {
	const splittedPath = pathName?.split("/").filter((element) => element) || [];
	return splittedPath[splittedPath.length - 1] || "";
};

export const objectIsEmpty = (object) => !Object.keys(object || {}).length;

export const triggerInterstitialByClassName = (interstitials, setModal) => {
	const linksWithInterstitial = document.querySelectorAll(
		".help-content a.triggerInterstitialModal"
	);
	linksWithInterstitial.forEach((anchor) => {
		const modal = { ...interstitials?.[anchor?.classList?.[1]] };
		const analyticsPrefix = "&lid=";
		if (!objectIsEmpty(modal)) {
			anchor.onclick = (e) => {
				e.preventDefault();
				if (anchor.href) {
					modal.href = anchor.href;
				}
				if (anchor.target) {
					modal.target = anchor.target;
				}
				if (anchor.name?.includes(analyticsPrefix)) {
					modal.primaryButtonAnalyticsLinkId = anchor.name.replace(
						analyticsPrefix,
						""
					);
				}
				setModal(modal);
			};
		}
	});
};

export const getParam = (parameter) => {
	const { search } = window.location;
	const params = new URLSearchParams(search);
	return params.get(parameter);
};

export const formatFileSize = (bytes, decimals = 2) => {
	if (!+bytes) return "0 Bytes";

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const triggerInterstitialByTargetOrHref = (
	event,
	interstitials,
	target,
	href,
	analyticsLinkId,
	setModal
) => {
	const interstitialPrefix = "interstitial";
	const hrefWithInterstitial = href.match(/(^#interstitial).+/g)?.[0];
	const interstitialName = hrefWithInterstitial?.split("#")?.[1];
	const modalId = interstitialName || target;
	if (modalId.includes(interstitialPrefix)) {
		const modal = { ...interstitials[modalId] };
		if (!objectIsEmpty(modal)) {
			event.preventDefault();
			if (href) {
				modal.href = hrefWithInterstitial
					? href.replace(`#${interstitialName}#`, "")
					: href;
			}

			if (target && !target?.includes(interstitialPrefix)) {
				modal.target = target;
			}

			if (analyticsLinkId) {
				modal.primaryButtonAnalyticsLinkId = analyticsLinkId;
			}
			setModal(modal);
		}
	}
};

export const getBrowserName = () => {
	const agent = window.navigator.userAgent.toLowerCase();
	if (agent.indexOf("edge") > -1) {
		return "MS Edge";
	}
	if (agent.indexOf("edg/") > -1) {
		return "Edge ( chromium based)";
	}
	if (agent.indexOf("opr") > -1 && !!window.opr) {
		return "Opera";
	}
	if (agent.indexOf("chrome") > -1 && !!window.chrome) {
		return "Chrome";
	}
	if (agent.indexOf("trident") > -1) {
		return "MS IE";
	}
	if (agent.indexOf("firefox") > -1) {
		return "Mozilla Firefox";
	}
	if (agent.indexOf("safari") > -1) {
		return "Safari";
	}
	return "other";
};

export const groupForm = (formList = [], num) => {
	const group = [];
	for (let i = 0; i < formList.length; i += num) {
		group.push(formList.slice(i, i + num));
	}
	return group;
};

export const isString = (value) => {
	return value != null && typeof value.valueOf() === "string";
};

export const isCustomForm = () => {
	return isCurrentPathPresent(["/heroesticket/*"]);
};

export const shouldShowInineErrors = () => {
	//Add more logic if needed
	return isCustomForm();
};
